import { Descriptions } from "@/components/v2";
import { type DescriptionsProps, Popconfirm, Space } from "antd";
import { Link } from "react-router-dom";
import { SmsTemplate } from "@rumble-it/common-lib/types/models/SmsTemplate.interface";
import { UseMutationResult } from "@tanstack/react-query";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Card } from "@rumbledirect/ui";

interface SmsTemplateDetailCardProps {
  smsTemplate: SmsTemplate | undefined;
  isLoading?: boolean;
  deleteMutation?: UseMutationResult<null, Error, void, unknown>;
}

export const SmsTemplateDetailCard = ({
  smsTemplate,
  isLoading,
  deleteMutation,
}: SmsTemplateDetailCardProps) => {
  const items: DescriptionsProps["items"] = [
    {
      label: "Titel",
      children: smsTemplate?.title ?? null,
    },
    {
      label: "Inhoud",
      children: smsTemplate?.contents ?? null,
    },
    {
      label: "Taal",
      children: smsTemplate?.language ?? null,
    },
  ];

  return (
    <Card
      loading={isLoading}
      className="w-full"
      title="SMS Template"
      extra={
        <Space>
          <Link to={`/sms-templates/${smsTemplate?.id}/edit`}>
            <Button icon={<EditOutlined />} />
          </Link>
          <Popconfirm
            title="SMS Template verwijderen"
            description="Weet je zeker dat je deze SMS Template wilt verwijderen?"
            onConfirm={() => deleteMutation?.mutate()}
            okText="Ja"
            cancelText="Nee"
          >
            <Button
              loading={deleteMutation?.isPending}
              danger
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        </Space>
      }
    >
      <Descriptions items={items} />
    </Card>
  );
};
